import React from "react";
import { Box, Dialog, Grid, IconButton } from "@mui/material";
import BestPairedDesktop from "./BestPairedDesktop";
import CloseIcon from "@mui/icons-material/Close";

interface BestPairedDesktopWraperProps {
  openBestPaired: any;
  setOpenBestPaired: any;
  recommendedServices: any;
  handleViewDetails: any;
  updateCard: any;
  setUpdateCard: any;
  reloadViewDetailsItem: any;
  handleOpenViewDetailsRsOne: any;
}

export const BestPairedDesktopWraper: React.FC<
  BestPairedDesktopWraperProps
> = ({
  openBestPaired,
  setOpenBestPaired,
  recommendedServices,
  handleViewDetails,
  updateCard,
  setUpdateCard,
  reloadViewDetailsItem,
  handleOpenViewDetailsRsOne,
}) => {
  return (
    <Dialog
      open={openBestPaired}
      onClose={() => setOpenBestPaired(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="md"
      fullWidth
      sx={{ maxWidth: "800px", margin: "auto" }}
    >
      <Box
        sx={{
          width: "100%",
          overflow: "scroll",
          padding: "0.5rem",
          background: "#fff",
          margin: "auto",
          textAlign: "center",
          "&:: -webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        <Box sx={{ width: "100%", textAlign: "end" }}>
          <IconButton onClick={() => setOpenBestPaired(false)}>
            <CloseIcon sx={{ cursor: "pointer", color: "#000" }} />
          </IconButton>
        </Box>
        <Grid container xs={12} sm={12} md={12} lg={12}>
          {recommendedServices?.map((item: any, index: any) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={4}
              key={index}
              justifyItems="center"
            >
              <BestPairedDesktop
                addOn={item?.addOn}
                id={item?.id}
                cid={item?.cid}
                url={
                  item?.banner?.secureHttpPath ??
                  item?.coverImage.secureHttpPath
                }
                heading={item?.name}
                subHeading={item?.subHeading}
                price={item?.mrp}
                finalPrice={item?.amount}
                aboutList={item?.aboutList}
                serviceCharge={item?.serviceCharge}
                productCost={item?.productCost}
                min={item?.min}
                specialPrice={item?.specialPrice}
                specialMessage={item?.specialMessage}
                handleViewDetailsBestPaired={() => handleViewDetails(item)}
                updateCard={updateCard}
                setUpdateCard={() => setUpdateCard(false)}
                reloadViewDetailsItem={reloadViewDetailsItem}
                productDetailsAvailable={item?.productDetailsAvailable}
                handleOpenViewDetailsRsOne={() =>
                  handleOpenViewDetailsRsOne(item, index)
                }
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Dialog>
  );
};
